<template>
  <div class="page-sign-todo">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">查詢快件</div>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <Table
        ref="table"
        size="small"
        border
        no-data-text="暫無數據"
        :columns="table.column"
        :data="table.data"
      >
        <!--<template slot-scope="{row,index}" slot="status">-->
        <!--    <span v-if="row.status == 0">珠海倉庫-待出庫</span>-->
        <!--    <span v-else-if="row.status == 1">珠海倉庫-已出庫</span>-->
        <!--    <span v-else-if="row.status == 2">澳門倉庫-配送中</span>-->
        <!--    <span v-else-if="row.status == 3 && row.addressType == '門店'">澳門門店-未簽收</span>-->
        <!--    <span v-else-if="row.status == 4 && row.addressType == '門店'">澳門門店-已簽收</span>-->
        <!--    <span v-else-if="row.status == 3 && row.addressType == '智能櫃'">智能櫃-未簽收</span>-->
        <!--    <span v-else-if="row.status == 4 && row.addressType == '智能櫃'">智能櫃-已簽收</span>-->
        <!--</template>-->
        <template slot-scope="{ row, index }" slot="status">
          <span>{{ row.status }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div class="pg-btn-wrap">
            <div class="pg-btn style2" @click="handleViewDetail(row)">
              快遞信息
            </div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="12" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
                  v-model="curPageSize"
                  size="small"
                  placeholder="數量"
                  @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
                  size="small"
                  v-model="pageInput"
                  @on-keyup="handlePageInput"
                  @on-enter="handlePageEnter"
                />
              </div>

              <Page
                size="small"
                :current="pageIndex"
                :page-size="curPageSize"
                :total="totalCount"
                @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
// import Store from '../../assets/js/store.js'

export default {
  data() {
    return {
      pageIndex: 1, //頁碼
      curPageSize: 10, //一頁數量
      totalCount: 0, //總條數
      pageInput: '', //輸入的頁碼
      isSubmiting: false,

      table: {
        column: [
          {
            title: '操作',
            slot: 'action',
            align: 'center',
            width: 100,
          },
	        {
		        title: '备注',
		        slot: 'remarks',
		        align: 'center',
		        sortable: true,
		        width: 80,
	        },
          {
            title: '更新時間',
            key: 'created_time',
            align: 'center',
            sortable: true,
            width: 160,
          },
	        
          {
            title: '快件單號',
            key: 'order',
            align: 'center',
            sortable: true,
            minWidth: 130,
          },
          {
            title: '店件/櫃件',
            key: 'store',
            align: 'center',
            sortable: true,
            width: 130,
          },
          {
            title: '客戶名稱',
            key: 'username',
            align: 'center',
            sortable: true,
            width: 100,
          },
          {
            title: '客戶電話',
            key: 'phone',
            align: 'center',
            sortable: true,
          },
          // {
          //     title: '快遞單號',
          //     key: 'order',
          //     align: 'center',
          //     sortable: true,
          //     minWidth: 130
          // },
          {
            title: '狀態',
            slot: 'status',
            align: 'center',
            sortable: true,
            width: 80,
          },
        ],
        data: [],
      },
    }
  },
  computed: {
    keyWord() {
      if (this.$store.getters.syncKyeWord) {
        this.getList(this.$store.getters.syncKyeWord)
      }
      return this.$store.getters.syncKyeWord
    },
  },
  watch: {
    keyWord() {
      // let keyword = this.keyWord;
      // if (keyword) {
      // this.getList(keyword);
      // }
    },
  },
  // created() {
  //     this.getShelvesList();
  // },
  methods: {
    formatDate(datetime) {
      if (!datetime) return ''
      let dateTime = new Date(datetime)
      let year = dateTime.getFullYear()
      let month = dateTime.getMonth() + 1
      let date = dateTime.getDate()
      let hour = dateTime.getHours()
      let minute = dateTime.getMinutes()
      let second = dateTime.getSeconds()
      let milliseconds = dateTime.getMilliseconds()
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
        date
      )} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
        milliseconds
      )}`
    },
    formatNum(num) {
      return num < 10 ? '0' + num : num
    },
    getList(odd_numbers) {
      let form = this.form
      this.isSubmiting = true
	    this.table.data = []
	    this.totalCount = 0
      let data = {
        offset: (this.pageIndex - 1) * this.curPageSize,
        limit: this.curPageSize,
        odd_numbers: odd_numbers,
      }
      this.$Rq
        .requestAuth({
          url: this.$Api.all_search_new2,
          method: 'get',
          data,
        })
        .then((res) => {
          this.isSubmiting = false

          if (res.code == 0) {
            let tempArr = []
            let resData = res.data

            for (let i = 0; i < resData.data.length; i++) {
              tempArr.push({
                phone: resData.data[i].recipient_phone,

                username: resData.data[i].recipient_contacts,

                store:
                  resData.data[i].store == null
                    ? '- - -'
                    : resData.data[i].store.ReceivingName,

                add_price: resData.data[i].add_price,

                order: resData.data[i].odd_numbers,

                amount: resData.data[i].amount,

                addressType: resData.data[i].addressType,

                first_price: resData.data[i].first_price,

                freight_collect: resData.data[i].freight_collect,

                height: resData.data[i].height,

                long: resData.data[i].long,

                outTime_price: resData.data[i].outTime_price,

                pay_type: resData.data[i].pay_type,

                size: resData.data[i].size,

                status: resData.data[i].status,

                surcharge_price: resData.data[i].surcharge_price,

                weight: resData.data[i].weight,

                width: resData.data[i].width,

                created_time: resData.data[i].created_at,

                id: resData.data[i].id,
	              remarks: resData.data[i].remarks,
              })
            }
            this.totalCount = resData.count
            this.table.data = tempArr
          } else if (res.code == 1) {
            this.table.data = []
            this.pageIndex = 1
            this.totalCount = 0
            this.showTipInfo(res.msg)
          }
        })
        .catch((err) => {
          this.isSubmiting = false
        })
    },
    handleViewDetail(row) {
      console.log(row)
      let tableData = this.table.data
      this.$router.push({ path: '/homeDetail?orderid=' + row.id + '&order=' + row.order })
    },
    handleSearch() {
      this.pageIndex = 1
      // this.getList(this.$store.getters.syncKyeWord);
    },
    //pager
    handlePageSizeChange(value) {
      this.pageIndex = 1
      // this.getList(this.$store.getters.syncKyeWord);
    },
    handlePageInput() {
      let value = ('' + this.pageInput).replace(/\D/g, '')
      let pageCount = Math.floor(this.totalCount / this.curPageSize)
      if (value > pageCount) {
        value = pageCount
      }
      this.pageInput = value
    },
    handlePageEnter() {
      if (this.pageInput == '' || this.pageInput == this.pageIndex) return
      if (this.pageInput == 0) {
        this.pageInput = 1
      }
      this.pageInput = parseInt(this.pageInput)
      this.pageIndex = this.pageInput
      // this.getList(this.$store.getters.syncKyeWord);
    },
    handlePageChange(value) {
      this.pageIndex = value
      // this.getList(this.$store.getters.syncKyeWord);
    },
  },
}
</script>

<style lang="scss">
@import 'Home.scss';
</style>
